<template>
  <span class="icon-w">
    <svg xmlns="http://www.w3.org/2000/svg" :class="'icon-' + iconName" :width="width" :height="height" :viewBox="viewBox" :aria-labelledby="iconName" role="presentation">
      <g :fill="iconColor">
        <slot />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class IconBase extends Vue {
  @Prop({ default: 18 }) readonly height!: number;
  @Prop({ default: "currentColor" }) readonly iconColor!: string;
  @Prop({ default: "box" }) readonly iconName!: string;
  @Prop({ default: "0 0 18 18" }) readonly viewBox!: string;
  @Prop({ default: 18 }) readonly width!: number;
}
</script>

<style lang="scss" scoped>
.icon-w {
  display: flex;
  align-items: center;
  justify-content: center;
}
svg {
  display: inline-block;
  vertical-align: baseline;
}
</style>
